module.exports = __webpack_public_path__ + "media/country_flags/eg-a55c5dd5.png";